const nav = document.querySelector(".product-board-nav");
const trigger = document.querySelector(".mobile-trigger");

if(nav && trigger){
    trigger.addEventListener("click", function () {
        nav.classList.toggle("open");
    });
}


/** Light On Feature */
class LightOnToggle {
  constructor(container) {
    this.container = container;
    this.button = container.querySelector('.light-toggle__button');
    this.buttonLabel = container.querySelector('.light-toggle__label');
    this.productGrid = document.querySelector('section.section.section-product-landing');
    this.isActive = true;
    this.isInTransition = false;
    this.images = [];

    this.init();
  }

  init() {
    if (!this.button || !this.productGrid) return;

    this.images = Array.from(
      this.productGrid.querySelectorAll('.image.image-cover[data-light-on]')
    ).map((img) => ({
      el: img,
      gallery: img.closest('.product-card-gallery'),
      lcpImage: img.closest('.product-card-gallery')
        ? img.closest('.product-card-gallery').querySelector('.product-card-lcp-image')
        : null,
      defaultBg: img.getAttribute('data-bg'),
      lightOffBg: img.getAttribute('data-light-off') || img.getAttribute('data-bg'),
      lightOnBg: img.getAttribute('data-light-on').replace(/^url\(["']?/, '').replace(/["']?\)$/, '')
    }));

    this.button.addEventListener('click', () => this.toggle());
    this.renderState(true);
  }

  toggle() {
    if (this.isInTransition) return;

    this.isInTransition = true;
    this.isActive = !this.isActive;

    this.renderState();

    setTimeout(() => {
      this.isInTransition = false;
    }, 300);
  }

  renderState(isInitial) {

    this.container.classList.toggle('is-active', this.isActive);
    this.button.setAttribute('aria-pressed', this.isActive ? 'true' : 'false');
    this.buttonLabel.innerText = this.isActive ? 'Lights ON' : 'Lights OFF';

    this.images.forEach((item) => {
      var nextBg = this.isActive ? item.lightOnBg : item.lightOffBg;

      // On the initial render, unloaded lazy cards only get data-bg updated so the
      // viewport loader fetches the correct state on scroll — writing
      // style.backgroundImage here forced every card to download immediately.
      if (!isInitial || item.el.classList.contains('loaded') || !item.el.classList.contains('lazy-bg')) {
        item.el.style.backgroundImage = 'url(' + nextBg + ')';
      }
      item.el.setAttribute('data-bg', nextBg);

      if (item.gallery) {
        item.gallery.classList.remove('is-gallery-active');
        item.gallery.setAttribute('data-gallery-index', this.isActive ? '0' : '1');
      }

      if (item.lcpImage) {
        item.lcpImage.src = nextBg;
        item.lcpImage.removeAttribute('srcset');
      }
    });
  }
}

document.querySelectorAll('[data-toggle]').forEach((toggleEl) => {
  new LightOnToggle(toggleEl);
});
document.addEventListener('DOMContentLoaded', function () {
  var announcementBar = document.querySelector('.announcement-bar');
  var announcementClose = document.querySelector('.announcement-bar-close');
  var storageKey = 'announcementBarClosedThisSession';

  if (!announcementBar) return;

  if (sessionStorage.getItem(storageKey) === 'true') {
    announcementBar.style.display = 'none';
    document.body.classList.remove('is-announcement-bar');
    document.body.classList.remove('announcement-bar-scrolled');
  }

  if (announcementClose) {
    announcementClose.addEventListener('click', function () {
      sessionStorage.setItem(storageKey, 'true');

      announcementBar.style.display = 'none';
      document.body.classList.remove('is-announcement-bar');
      document.body.classList.remove('announcement-bar-scrolled');
    });
  }
});
document.addEventListener('change', function (event) {
  var input = event.target;

  if (!input.matches('.product-form input[type="radio"][name="id"]')) return;

  var selectedVariantId = input.value;

  document.querySelectorAll('.display-for-variant').forEach(function (block) {
    if (block.getAttribute('data-variant-id') === selectedVariantId) {
      block.classList.add('show');
      block.classList.remove('hide');
    } else {
      block.classList.remove('show');
    }
  });

  var enquireButton = document.getElementById('enquire_btn');
  var enquire = document.getElementById('enquire');

  if (enquireButton) {
    enquireButton.classList.remove('active');
    enquireButton.checked = false;
  }

  if (enquire) {
    enquire.classList.remove('active');
  }
});
document.addEventListener('DOMContentLoaded', function () {
  var preloadedProductCardImages = Object.create(null);

  function preloadProductCardImage(url) {
    if (!url) return null;

    if (preloadedProductCardImages[url]) {
      return preloadedProductCardImages[url];
    }

    var preload = new Image();
    preload.src = url;
    preloadedProductCardImages[url] = preload;
    return preload;
  }

  function preloadProductCardImages(urls) {
    urls.forEach(function (url) {
      preloadProductCardImage(url);
    });
  }

  function whenProductCardImageReady(url, callback) {
    var preload = preloadProductCardImage(url);

    if (!preload) return;

    if (preload.complete) {
      callback();
      return;
    }

    preload.onload = callback;
  }

  function initProductCardGallery(gallery) {
    if (gallery.getAttribute('data-gallery-ready') === 'true') return;
    gallery.setAttribute('data-gallery-ready', 'true');

    var image = gallery.querySelector('.image.image-cover');
    var hoverImage = gallery.querySelector('.image-hover');
    var prev = gallery.querySelector('.product-card-gallery__arrow--prev');
    var next = gallery.querySelector('.product-card-gallery__arrow--next');
    var progress = null;
    var progressThumb = null;
    var images = [];
    var hoverImageUrl = hoverImage ? hoverImage.getAttribute('data-bg') : null;
    var touchStartX = null;
    var didSwipe = false;

    try {
      images = JSON.parse(gallery.getAttribute('data-gallery-images') || '[]');
    } catch (error) {
      images = [];
    }

    // Preloading every card's full gallery on page load cost several MB per collection
    // page. Warm the cache on first interaction instead — by the time an arrow is
    // clicked or the hover fades in, the downloads are already in flight.
    var galleryWarmedUp = false;
    function warmUpGallery() {
      if (galleryWarmedUp) return;
      galleryWarmedUp = true;
      if (hoverImageUrl) preloadProductCardImages([hoverImageUrl]);
      preloadProductCardImages(images);
    }
    gallery.addEventListener('pointerenter', warmUpGallery, { once: true });
    gallery.addEventListener('touchstart', warmUpGallery, { once: true, passive: true });

    if (!image || images.length < 2) return;

    progress = document.createElement('div');
    progress.className = 'product-card-gallery__progress';
    progress.setAttribute('aria-hidden', 'true');
    progressThumb = document.createElement('span');
    progressThumb.className = 'product-card-gallery__progress-thumb';
    progressThumb.style.width = (100 / images.length) + '%';
    progress.appendChild(progressThumb);
    gallery.appendChild(progress);

    function setImage(index) {
      var safeIndex = (index + images.length) % images.length;
      var nextImage = images[safeIndex];

      whenProductCardImageReady(nextImage, function () {
        gallery.setAttribute('data-gallery-index', safeIndex);
        image.removeAttribute('data-bg');
        image.style.backgroundImage = 'url(' + nextImage + ')';
        image.classList.add('loaded');
        progressThumb.style.transform = 'translateX(' + (safeIndex * 100) + '%)';
      });
    }

    function restorePrimaryImage() {
      var activeLightToggle = document.querySelector(
        '.light-toggle.is-active .light-toggle__button[aria-pressed="true"]'
      );
      var lightOnImage = image.getAttribute('data-light-on');

      if (activeLightToggle && lightOnImage) {
        lightOnImage = lightOnImage.replace(/^url\(["']?/, '').replace(/["']?\)$/, '');

        whenProductCardImageReady(lightOnImage, function () {
          gallery.setAttribute('data-gallery-index', '0');
          image.style.backgroundImage = 'url(' + lightOnImage + ')';
          image.setAttribute('data-bg', lightOnImage);
          image.classList.add('loaded');
        });
        return;
      }

      setImage(0);
    }

    function move(direction) {
      var current = parseInt(gallery.getAttribute('data-gallery-index') || '0', 10);
      gallery.classList.add('is-gallery-active');
      setImage(current + direction);
    }

    if (prev) {
      prev.addEventListener('pointerdown', function (event) {
        event.preventDefault();
        event.stopPropagation();
      });
      prev.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        move(-1);
      });
    }

    if (next) {
      next.addEventListener('pointerdown', function (event) {
        event.preventDefault();
        event.stopPropagation();
      });
      next.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        move(1);
      });
    }

    if (window.matchMedia('(hover: hover) and (min-width: 769px)').matches) {
      gallery.addEventListener('mouseleave', function () {
        gallery.classList.remove('is-gallery-active');
        restorePrimaryImage();
      });
    }

    gallery.addEventListener('touchstart', function (event) {
      touchStartX = event.changedTouches[0].clientX;
      didSwipe = false;
    }, { passive: true });

    gallery.addEventListener('touchend', function (event) {
      if (touchStartX === null) return;

      var deltaX = event.changedTouches[0].clientX - touchStartX;
      touchStartX = null;

      if (Math.abs(deltaX) < 22) return;

      didSwipe = true;
      move(deltaX < 0 ? 1 : -1);
    }, { passive: true });

    gallery.addEventListener('click', function (event) {
      if (!didSwipe) return;

      event.preventDefault();
      event.stopPropagation();
      didSwipe = false;
    }, true);
  }

  document.querySelectorAll('.product-card-gallery').forEach(initProductCardGallery);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches('.product-card-gallery')) initProductCardGallery(node);
        node.querySelectorAll('.product-card-gallery').forEach(initProductCardGallery);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
});
/* ===== CreativeFold — Enquire -> Shopify Forms modal (Form 1054979, shadow DOM embed) ===== */
(function () {
  var modal, panel, moved = false;
  function embed(){ return document.querySelector('shopify-forms-embed'); }
  function productValue(){
    var btn = document.getElementById('enquire');
    var title = btn ? (btn.getAttribute('data-product-title') || '') : '';
    var sizeEl = document.querySelector('.product-variant-radios input:checked + label');
    var size = sizeEl ? sizeEl.textContent.trim() : '';
    return (size && !/one size|default/i.test(size)) ? (title + ' – ' + size) : title;
  }
  function prefill(){
    var e = embed(); if (!e || !e.shadowRoot) return;
    var lab = [].slice.call(e.shadowRoot.querySelectorAll('label')).find(function(l){ return /product/i.test(l.textContent); });
    var input = lab && (lab.control || (lab.parentElement && lab.parentElement.querySelector('input,textarea')));
    if (input) {
      input.value = productValue();
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  function buildModal(){
    modal = document.createElement('div');
    modal.className = 'cf-modal';
    modal.setAttribute('hidden', '');
    modal.innerHTML = '<div class="cf-modal__panel" role="dialog" aria-modal="true" aria-label="Product enquiry">' +
      '<button type="button" class="cf-modal__close" aria-label="Close">×</button>' +
      '<div class="cf-modal__slot"></div></div>';
    document.body.appendChild(modal);
    panel = modal.querySelector('.cf-modal__slot');
    modal.addEventListener('click', function(e){ if (e.target === modal || (e.target.closest && e.target.closest('.cf-modal__close'))) close(); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && modal && !modal.hasAttribute('hidden')) close(); });
  }
  function styleEmbedTitle(e){
    try {
      var sr = e && e.shadowRoot;
      if (!sr || sr.querySelector('style[data-cf-title-font]')) return;
      var st = document.createElement('style');
      st.setAttribute('data-cf-title-font', '1');
      /* restyle the form's heading + submit button to match the theme (din_condensedbold) */
      st.textContent = 'h1,h2,h3,h4{font-family:"din_condensedbold","Arial",sans-serif !important;text-transform:uppercase;letter-spacing:normal}'
        + ' button[type="submit"],input[type="submit"],[type="submit"]{font-family:"din_condensedbold","Arial",sans-serif !important;text-transform:uppercase !important;letter-spacing:.04em !important}';
      sr.appendChild(st);
    } catch (err) {}
  }
  function open(){
    var e = embed();
    if (!e) { window.location.href = '/pages/contact?source=product-enquiry'; return; }
    if (!modal) buildModal();
    if (!moved) { panel.appendChild(e); e.style.display = ''; moved = true; }
    styleEmbedTitle(e); setTimeout(function(){ styleEmbedTitle(e); }, 300);
    modal.removeAttribute('hidden');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(prefill, 80); setTimeout(prefill, 500);
  }
  function close(){ if (!modal) return; modal.setAttribute('hidden', ''); document.documentElement.style.overflow = ''; }
  document.addEventListener('click', function(e){
    var t = e.target.closest && e.target.closest('#enquire');
    if (t) { e.preventDefault(); open(); }
  });
  var tries = 0;
  (function init(){
    var e = embed();
    if (e) { var sec = e.closest('.shopify-section') || e.parentElement; if (sec) sec.classList.add('cf-enquiry-hidden'); }
    else if (tries++ < 30) { setTimeout(init, 300); }
  })();
})();

/* ===== Mobile PDP full-screen gallery =====
   Moves the existing Swiper into a fixed viewer so its swipe and zoom
   behaviour continue to work, then restores it to the PDP on close. */
(function () {
  if (!window.matchMedia('(max-width: 768px)').matches) return;

  window.addEventListener('load', function () {
    document.querySelectorAll('.productswiper').forEach(function (gallery) {
      var overlay = null;
      var placeholder = null;
      var previousFocus = null;

      function pauseGalleryVideos() {
        gallery.querySelectorAll('video.pdp-gallery-video').forEach(function (video) {
          video.pause();
        });
      }

      function playActiveVideo() {
        pauseGalleryVideos();
        var activeVideo = gallery.querySelector('.swiper-slide-active video.pdp-gallery-video');
        if (!activeVideo) return;
        activeVideo.muted = true;
        var playPromise = activeVideo.play();
        if (playPromise && playPromise.catch) playPromise.catch(function () {});
      }

      function closeViewer() {
        if (!overlay || !placeholder || !placeholder.parentNode) return;

        if (gallery.swiper && gallery.swiper.zoom) gallery.swiper.zoom.out();
        if (gallery.swiper) {
          gallery.swiper.allowSlideNext = true;
          gallery.swiper.allowSlidePrev = true;
        }
        placeholder.parentNode.insertBefore(gallery, placeholder);
        placeholder.parentNode.removeChild(placeholder);
        gallery.classList.remove('cf-mobile-zoom-gallery');
        overlay.parentNode.removeChild(overlay);
        document.documentElement.classList.remove('cf-mobile-zoom-open');
        document.body.classList.remove('cf-mobile-zoom-open');

        if (gallery.swiper) gallery.swiper.update();
        if (previousFocus && previousFocus.focus) previousFocus.focus();

        overlay = null;
        placeholder = null;
      }

      function openViewer() {
        if (overlay) return;

        previousFocus = document.activeElement;
        placeholder = document.createComment('product gallery position');
        gallery.parentNode.insertBefore(placeholder, gallery);

        overlay = document.createElement('div');
        overlay.className = 'cf-mobile-zoom-overlay';
        overlay.setAttribute('role', 'dialog');
        overlay.setAttribute('aria-modal', 'true');
        overlay.setAttribute('aria-label', 'Product image gallery');

        var closeButton = document.createElement('button');
        closeButton.type = 'button';
        closeButton.className = 'cf-mobile-zoom-close';
        closeButton.setAttribute('aria-label', 'Close product image gallery');
        closeButton.innerHTML = '<span aria-hidden="true"></span>';
        closeButton.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          closeViewer();
        });

        overlay.appendChild(closeButton);
        gallery.classList.add('cf-mobile-zoom-gallery');
        overlay.appendChild(gallery);
        document.body.appendChild(overlay);
        document.documentElement.classList.add('cf-mobile-zoom-open');
        document.body.classList.add('cf-mobile-zoom-open');

        if (gallery.swiper) {
          gallery.swiper.update();
          if (gallery.swiper.params && gallery.swiper.params.zoom) {
            gallery.swiper.params.zoom.maxRatio = 2;
          }
          if (gallery.swiper.zoom) gallery.swiper.zoom.out();
          gallery.swiper.allowSlideNext = true;
          gallery.swiper.allowSlidePrev = true;
          playActiveVideo();
        }
        closeButton.focus();
      }

      if (gallery.swiper) {
        gallery.swiper.on('slideChangeTransitionStart', pauseGalleryVideos);
        gallery.swiper.on('slideChangeTransitionEnd', playActiveVideo);
        gallery.swiper.on('zoomChange', function (swiper, scale) {
          if (!overlay) return;
          var canChangeImage = scale <= 1.01;
          swiper.allowSlideNext = canChangeImage;
          swiper.allowSlidePrev = canChangeImage;
        });
        playActiveVideo();
      }

      gallery.addEventListener('click', function () {
        if (!overlay && gallery.swiper && gallery.swiper.allowClick === false) return;
        if (!overlay) openViewer();
      });

      document.addEventListener('keydown', function (event) {
        if (overlay && event.key === 'Escape') closeViewer();
      });
    });
  });
})();

/* Play desktop PDP videos only while their gallery card is visible. */
(function () {
  window.addEventListener('load', function () {
    var videos = document.querySelectorAll('.desktop-gallery video.pdp-gallery-video');
    if (!videos.length || !window.IntersectionObserver) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.55) {
          video.muted = true;
          var playPromise = video.play();
          if (playPromise && playPromise.catch) playPromise.catch(function () {});
        } else {
          video.pause();
        }
      });
    }, { threshold: [0, 0.55] });

    videos.forEach(function (video) { observer.observe(video); });
  });
})();

/* ===== CreativeFold — Desktop gallery thumbnail swap ===== */
(function () {
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest && e.target.closest('.cf-thumb');
    if (!thumb) return;
    e.preventDefault();
    var g = thumb.closest('.cf-gallery');
    var main = g && g.querySelector('.cf-gallery__img');
    if (!main) return;
    if (thumb.dataset.full) main.src = thumb.dataset.full;
    if (thumb.dataset.w) main.setAttribute('width', thumb.dataset.w);
    if (thumb.dataset.h) main.setAttribute('height', thumb.dataset.h);
    if (thumb.dataset.zoom) main.setAttribute('data-zoom-src', thumb.dataset.zoom);
    main.setAttribute('data-image-index', thumb.dataset.index || '0');
    main.setAttribute('data-zoom-orientation', thumb.dataset.orientation || 'portrait');
    [].forEach.call(g.querySelectorAll('.cf-thumb'), function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });
})();

/* ===== CreativeFold — Mobile gallery thumbnail strip synced to swiper ===== */
(function () {
  function wire(scope) {
    var swiperEl = scope.querySelector('.productswiper');
    var strip = scope.querySelector('.cf-mthumbs');
    if (!swiperEl || !strip) return true; /* nothing to wire here */
    var sw = swiperEl.swiper;
    if (!sw) return false; /* swiper not initialised yet */
    var btns = [].slice.call(strip.querySelectorAll('.cf-mthumb'));
    function setActive(i) {
      btns.forEach(function (b, idx) { b.classList.toggle('is-active', idx === i); });
      if (btns[i]) btns[i].scrollIntoView({ inline: 'nearest', block: 'nearest' });
    }
    strip.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.cf-mthumb');
      if (!b) return;
      var i = parseInt(b.getAttribute('data-index'), 10) || 0;
      if (sw.params && sw.params.loop && sw.slideToLoop) sw.slideToLoop(i); else sw.slideTo(i);
    });
    sw.on('slideChange', function () { setActive(typeof sw.realIndex === 'number' ? sw.realIndex : sw.activeIndex); });
    setActive(sw.realIndex || 0);
    return true;
  }
  var tries = 0;
  (function init() {
    var scopes = [].slice.call(document.querySelectorAll('.productswiper-wrap .display-for-variant'));
    var pending = false;
    scopes.forEach(function (s) { if (!s.__cfThumbsWired) { if (wire(s)) s.__cfThumbsWired = true; else pending = true; } });
    if (pending && tries++ < 40) setTimeout(init, 300);
  })();
})();

/* ===== CreativeFold — Footer Klaviyo signup: set email placeholder (form renders async) ===== */
(function () {
  var TEXT = 'Enter your email address';
  function apply() {
    var form = document.querySelector('.klaviyo-form-V4Xt2f');
    if (!form) return false;
    var input = form.querySelector('input[type="email"], input[type="text"]:not([type="hidden"])');
    if (input && input.placeholder !== TEXT) input.setAttribute('placeholder', TEXT);
    return !!input;
  }
  if (apply()) return;
  var tries = 0;
  var iv = setInterval(function () { if (apply() || tries++ > 40) clearInterval(iv); }, 300);
  // Klaviyo can re-render on interaction — keep the placeholder set
  var host = document.querySelector('.klaviyo-form-V4Xt2f');
  if (host && window.MutationObserver) { new MutationObserver(apply).observe(host, { childList: true, subtree: true }); }
})();
/* Dynamic Finish the Look recommendations */
document.addEventListener('DOMContentLoaded', function () {
  var dataElement = document.querySelector('[data-finish-look-data]');
  var section = document.querySelector('[data-finish-look]');
  var productList = document.querySelector('[data-finish-look-products]');

  if (!dataElement || !section || !productList) return;

  var context;
  try {
    context = JSON.parse(dataElement.textContent);
  } catch (error) {
    return;
  }

  var storageKey = 'theendRecentlyViewed';
  var recentHandles = [];

  try {
    recentHandles = JSON.parse(localStorage.getItem(storageKey) || '[]');
    if (!Array.isArray(recentHandles)) recentHandles = [];
  } catch (error) {
    recentHandles = [];
  }

  recentHandles = recentHandles.filter(function (handle) {
    return handle && handle !== context.handle;
  }).slice(0, 11);

  try {
    localStorage.setItem(storageKey, JSON.stringify([context.handle].concat(recentHandles)));
  } catch (error) {}

  function tagsWithPrefix(tags, prefix) {
    return (tags || []).filter(function (tag) {
      return String(tag).toLowerCase().indexOf(prefix) === 0;
    }).map(function (tag) {
      return String(tag).toLowerCase();
    });
  }

  function inferProductTags(product) {
    var tags = (product.tags || []).slice();
    var searchable = [product.title, product.type, product.handle].filter(Boolean).join(' ').toLowerCase();

    function addTag(tag) {
      if (tags.map(function (item) { return String(item).toLowerCase(); }).indexOf(tag) === -1) {
        tags.push(tag);
      }
    }

    if (/mirror/.test(searchable)) {
      addTag('category:decor');
      addTag('subcategory:mirrors');
    }
    if (/dining[ -]?table/.test(searchable)) {
      addTag('category:tables');
      addTag('subcategory:dining-tables');
    } else if (/coffee[ -]?table/.test(searchable)) {
      addTag('category:tables');
      addTag('subcategory:coffee-tables');
    } else if (/side[ -]?table/.test(searchable)) {
      addTag('category:tables');
      addTag('subcategory:side-tables');
    } else if (/table/.test(searchable)) {
      addTag('category:tables');
    }
    if (/dining[ -]?chair/.test(searchable)) {
      addTag('category:seating');
      addTag('subcategory:dining-chairs');
    } else if (/chair|seat|bench/.test(searchable)) {
      addTag('category:seating');
    }
    if (/lamp|sconce|pendant|chandelier|light/.test(searchable)) {
      addTag('category:lighting');
    }
    if (/console|cabinet|sideboard|shelf|storage/.test(searchable)) {
      addTag('category:storage');
    }
    if (/sculpture|sculptural|statue|object/.test(searchable)) {
      addTag('category:decor');
      addTag('subcategory:sculpture');
    }

    var type = String(product.type || '').toLowerCase();
    if (type.indexOf('seating') !== -1) addTag('category:seating');
    if (type.indexOf('table') !== -1) addTag('category:tables');
    if (type.indexOf('light') !== -1) addTag('category:lighting');
    if (type.indexOf('storage') !== -1) addTag('category:storage');
    if (type.indexOf('decor') !== -1) addTag('category:decor');

    return tags;
  }

  context.tags = inferProductTags(context);

  function sharesTag(left, right, prefix) {
    var leftTags = tagsWithPrefix(left, prefix);
    var rightTags = tagsWithPrefix(right, prefix);
    return leftTags.some(function (tag) { return rightTags.indexOf(tag) !== -1; });
  }

  function relationshipScore(candidate, anchors) {
    var score = anchors.reduce(function (total, anchor) {
      if (sharesTag(candidate.tags, anchor.tags, 'finish:')) total += 10;
      if (sharesTag(candidate.tags, anchor.tags, 'material:')) total += 7;
      if (sharesTag(candidate.tags, anchor.tags, 'room:')) total += 3;
      if (sharesTag(candidate.tags, anchor.tags, 'category:')) total += 1;
      return total;
    }, 0);

    if (score > 0 && !sharesTag(candidate.tags, context.tags, 'category:')) score += 25;
    return score;
  }

  function complementaryPriority(product) {
    var currentIsDiningChair = tagsWithPrefix(context.tags, 'subcategory:').indexOf('subcategory:dining-chairs') !== -1;
    var currentCategories = tagsWithPrefix(context.tags, 'category:');

    if (currentIsDiningChair) {
      if (tagsWithPrefix(product.tags, 'subcategory:').indexOf('subcategory:dining-tables') !== -1) return 0;
      if (tagsWithPrefix(product.tags, 'subcategory:').indexOf('subcategory:mirrors') !== -1) return 1;
      if (tagsWithPrefix(product.tags, 'category:').indexOf('category:lighting') !== -1) return 2;
      if (tagsWithPrefix(product.tags, 'category:').indexOf('category:tables') !== -1) return 3;
      if (tagsWithPrefix(product.tags, 'category:').indexOf('category:storage') !== -1) return 4;
      if (tagsWithPrefix(product.tags, 'category:').indexOf('category:decor') !== -1) return 5;
      return 9;
    }

    var categoryOrder = currentCategories.indexOf('category:tables') !== -1
      ? ['category:seating', 'category:lighting', 'subcategory:mirrors', 'category:storage', 'category:decor']
      : currentCategories.indexOf('category:lighting') !== -1
        ? ['category:tables', 'category:seating', 'subcategory:mirrors', 'category:decor']
        : currentCategories.indexOf('category:decor') !== -1
          ? ['category:tables', 'category:seating', 'category:lighting', 'category:storage', 'category:decor']
          : ['category:tables', 'subcategory:mirrors', 'category:lighting', 'category:storage', 'category:decor'];

    for (var i = 0; i < categoryOrder.length; i += 1) {
      var prefix = categoryOrder[i].split(':')[0] + ':';
      if (tagsWithPrefix(product.tags, prefix).indexOf(categoryOrder[i]) !== -1) return i;
    }

    return 9;
  }

  function diversifyProducts(products) {
    var sorted = (products || []).map(function (product, index) {
      return {
        product: product,
        index: index,
        priority: complementaryPriority(product)
      };
    }).sort(function (left, right) {
      if (left.priority !== right.priority) return left.priority - right.priority;
      return left.index - right.index;
    }).map(function (entry) {
      return entry.product;
    });

    var usedGroups = {};
    var diverse = [];
    var repeats = [];

    sorted.forEach(function (product) {
      var subcategories = tagsWithPrefix(product.tags, 'subcategory:');
      var categories = tagsWithPrefix(product.tags, 'category:');
      var group = subcategories[0] || categories[0] || product.handle;

      if (usedGroups[group]) {
        repeats.push(product);
      } else {
        usedGroups[group] = true;
        diverse.push(product);
      }
    });

    return diverse.concat(repeats);
  }

  function productIsAvailable(product) {
    if (typeof product.available === 'boolean') return product.available;
    return (product.variants || []).some(function (variant) { return variant.available; });
  }

  function addUnique(target, seen, products) {
    (products || []).forEach(function (product) {
      if (target.length >= 4) return;
      if (!product || !product.handle || product.handle === context.handle) return;
      if (seen[product.handle] || !productIsAvailable(product)) return;
      seen[product.handle] = true;
      target.push(product);
    });
  }

  function recommendationGroup(product) {
    var subcategories = tagsWithPrefix(product.tags, 'subcategory:');
    var categories = tagsWithPrefix(product.tags, 'category:');

    if (subcategories.indexOf('subcategory:mirrors') !== -1) return 'mirrors';
    if (subcategories.indexOf('subcategory:sculpture') !== -1) return 'sculpture';
    if (categories.indexOf('category:tables') !== -1) return 'tables';
    if (categories.indexOf('category:seating') !== -1) return 'seating';
    if (categories.indexOf('category:lighting') !== -1) return 'lighting';
    if (categories.indexOf('category:storage') !== -1) return 'storage';
    if (categories.indexOf('category:decor') !== -1) return 'decor';
    return subcategories[0] || categories[0] || product.handle;
  }

  function addDiverse(target, seen, usedGroups, products, allowRepeatedGroups) {
    (products || []).forEach(function (product) {
      if (target.length >= 4) return;
      if (!product || !product.handle || product.handle === context.handle) return;
      if (seen[product.handle] || !productIsAvailable(product)) return;

      var group = recommendationGroup(product);
      if (!allowRepeatedGroups && usedGroups[group]) return;

      seen[product.handle] = true;
      usedGroups[group] = true;
      target.push(product);
    });
  }

  function imageUrl(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function productPrice(product) {
    var price = product.price;
    if (!price) {
      var paidPrices = (product.variants || []).map(function (variant) {
        return variant.price;
      }).filter(function (variantPrice) { return variantPrice > 0; });
      if (paidPrices.length) price = Math.min.apply(Math, paidPrices);
    }

    var currency = window.Shopify && Shopify.currency && Shopify.currency.active
      ? Shopify.currency.active
      : 'AUD';

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: 0
      }).format((price || 0) / 100);
    } catch (error) {
      return '$' + ((price || 0) / 100).toLocaleString();
    }
  }

  function escapeHtml(value) {
    var element = document.createElement('div');
    element.textContent = value || '';
    return element.innerHTML;
  }

  function renderProduct(product) {
    var featuredImage = product.featured_image || (product.images && product.images[0]) || '';
    var imageMarkup = '';
    if (featuredImage) {
      imageMarkup = '<img class="cover-img" loading="lazy" alt="' + escapeHtml(product.title) + '"' +
        ' src="' + escapeHtml(imageUrl(featuredImage, 400)) + '"' +
        ' srcset="' + escapeHtml(imageUrl(featuredImage, 400)) + ' 400w, ' +
          escapeHtml(imageUrl(featuredImage, 600)) + ' 600w, ' +
          escapeHtml(imageUrl(featuredImage, 800)) + ' 800w"' +
        ' sizes="(min-width: 769px) 25vw, 50vw">';
    }
    return '<li>' +
      '<a class="product-card" href="/products/' + encodeURIComponent(product.handle) + '">' +
        '<div class="product-thumb">' +
          '<div class="image image-cover">' + imageMarkup + '</div>' +
        '</div>' +
        '<p><span>' + escapeHtml(product.title) + '</span>' +
        '<span class="price">' + escapeHtml(productPrice(product)) + '</span></p>' +
      '</a>' +
    '</li>';
  }

  Promise.all([
    fetch('/collections/all/products.json?limit=250&sort_by=best-selling').then(function (response) {
      return response.ok ? response.json() : { products: [] };
    }).catch(function () { return { products: [] }; }),
    fetch('/cart.js').then(function (response) {
      return response.ok ? response.json() : { items: [] };
    }).catch(function () { return { items: [] }; }),
    fetch('/recommendations/products.json?product_id=' + encodeURIComponent(context.productId) + '&limit=12&intent=related').then(function (response) {
      return response.ok ? response.json() : { products: [] };
    }).catch(function () { return { products: [] }; })
  ]).then(function (responses) {
    var catalogue = responses[0].products || [];
    var cart = responses[1];
    var automatic = responses[2].products || [];
    var byHandle = {};
    var byId = {};

    catalogue.forEach(function (product) {
      product.tags = inferProductTags(product);
      byHandle[product.handle] = product;
      byId[String(product.id)] = product;
    });

    automatic.forEach(function (product) {
      product.tags = inferProductTags(product);
    });

    var anchors = recentHandles.map(function (handle) {
      return byHandle[handle];
    }).filter(Boolean);

    (cart.items || []).forEach(function (item) {
      var cartProduct = byId[String(item.product_id)];
      if (cartProduct && !anchors.some(function (anchor) { return anchor.id === cartProduct.id; })) {
        anchors.push(cartProduct);
      }
    });

    var behavioural = catalogue.map(function (candidate) {
      return { product: candidate, score: relationshipScore(candidate, anchors) };
    }).filter(function (entry) {
      return entry.score > 0;
    }).sort(function (left, right) {
      return right.score - left.score;
    }).map(function (entry) { return entry.product; });

    var sameFinishDifferentCategory = catalogue.filter(function (candidate) {
      return sharesTag(candidate.tags, context.tags, 'finish:') &&
        !sharesTag(candidate.tags, context.tags, 'category:');
    });

    var manual = (context.manualHandles || []).map(function (handle) {
      return byHandle[handle] || { handle: handle, available: true };
    });

    var selected = [];
    var seen = {};
    var usedRecommendationGroups = {};
    var crossCategoryBehavioural = behavioural.filter(function (candidate) {
      return !sharesTag(candidate.tags, context.tags, 'category:');
    });
    var crossCategoryAutomatic = automatic.concat(catalogue).filter(function (candidate) {
      return !sharesTag(candidate.tags, context.tags, 'category:');
    });
    var sameCategoryFallback = behavioural.concat(automatic, catalogue).filter(function (candidate) {
      return sharesTag(candidate.tags, context.tags, 'category:');
    });

    addDiverse(selected, seen, usedRecommendationGroups, diversifyProducts(crossCategoryBehavioural), false);
    addDiverse(selected, seen, usedRecommendationGroups, diversifyProducts(sameFinishDifferentCategory), false);
    addDiverse(selected, seen, usedRecommendationGroups, manual, true);
    addDiverse(selected, seen, usedRecommendationGroups, diversifyProducts(crossCategoryAutomatic), false);
    addDiverse(selected, seen, usedRecommendationGroups, diversifyProducts(crossCategoryAutomatic), true);
    addDiverse(selected, seen, usedRecommendationGroups, diversifyProducts(sameCategoryFallback), false);
    addDiverse(selected, seen, usedRecommendationGroups, diversifyProducts(sameCategoryFallback), true);

    return Promise.all(selected.slice(0, 4).map(function (product) {
      return fetch('/products/' + encodeURIComponent(product.handle) + '.js').then(function (response) {
        return response.ok ? response.json() : product;
      }).catch(function () { return product; });
    }));
  }).then(function (products) {
    if (!products.length) return;
    productList.innerHTML = products.map(renderProduct).join('');
    section.hidden = false;
  });
});

/* Touch devices can never hover — strip hover-layer lazy backgrounds before the
   _global.js data-bg loader acts on them, so phones skip those downloads entirely. */
document.addEventListener('DOMContentLoaded', function () {
  if (window.matchMedia('(hover: none)').matches) {
    document.querySelectorAll('.image-hover[data-bg]').forEach(function (el) {
      el.removeAttribute('data-bg');
    });
  }
});

/* Reveal above-the-fold fade-in sections (.check-in-viewport) as soon as the DOM is
   ready instead of waiting for window load — same animation, it just starts seconds
   earlier on slow connections. highlightBit is defined in _global.js, which loads first. */
document.addEventListener('DOMContentLoaded', function () {
  if (typeof highlightBit === 'function') highlightBit();
});

/* ===== Desktop hover zoom on the product gallery (replaces the "+" lightbox).
   Magnifies ~2.2x in place, panning with the cursor. The zoom asset derives
   from the image's own URL at width=2000 so aspect/pan geometry match exactly,
   and it only downloads on first hover. Mobile gets Swiper's zoom module instead. ===== */
(function () {
  if (!window.matchMedia('(hover: hover) and (min-width: 769px)').matches) return;

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.desktop-gallery img.lazy-image').forEach(function (img) {
      var host = img.closest('li');
      if (!host) return;

      var pane = null;

      function ensurePane() {
        if (pane) return pane;
        // src attribute, not currentSrc — the hero img sits in a <picture> whose
        // breakpoint-gating <source> is a 1px gif, and currentSrc can resolve to it
        var zoomUrl = img.getAttribute('src').replace(/width=\d+/, 'width=2000');
        pane = document.createElement('div');
        pane.className = 'cf-zoom-pane';
        pane.style.backgroundImage = 'url(' + zoomUrl + ')';
        pane.style.backgroundSize = '220%';
        host.appendChild(pane);
        return pane;
      }

      host.addEventListener('mouseenter', function () {
        ensurePane().classList.add('is-active');
      });

      host.addEventListener('mousemove', function (event) {
        if (!pane) return;
        var rect = host.getBoundingClientRect();
        var x = ((event.clientX - rect.left) / rect.width) * 100;
        var y = ((event.clientY - rect.top) / rect.height) * 100;
        pane.style.backgroundPosition = x + '% ' + y + '%';
      });

      host.addEventListener('mouseleave', function () {
        if (pane) pane.classList.remove('is-active');
      });
    });
  });
})();

/* ===== Mobile zoom hint: a subtle magnifier badge on the product gallery that
   tells touch users the images are pinch/double-tap zoomable. Dismissed
   permanently (localStorage) the first time they zoom. ===== */
(function () {
  if (!window.matchMedia('(hover: none)').matches) return;
  try {
    if (localStorage.getItem('cfZoomHintSeen')) return;
  } catch (e) { /* private mode — show the hint, skip persistence */ }

  window.addEventListener('load', function () {
    var swipers = document.querySelectorAll('.productswiper');
    if (!swipers.length) return;

    var hints = [];
    function dismiss() {
      try { localStorage.setItem('cfZoomHintSeen', '1'); } catch (e) {}
      hints.forEach(function (hint) {
        hint.classList.add('is-dismissed');
        // Inline style so no theme rule with higher specificity can keep it visible
        hint.style.opacity = '0';
      });
    }

    swipers.forEach(function (el) {
      var hint = document.createElement('div');
      hint.className = 'cf-zoom-hint';
      hint.setAttribute('aria-hidden', 'true');
      hint.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><circle cx="10.5" cy="10.5" r="6.5"/><line x1="15.5" y1="15.5" x2="20" y2="20"/><line x1="10.5" y1="8" x2="10.5" y2="13"/><line x1="8" y1="10.5" x2="13" y2="10.5"/></svg>';
      el.appendChild(hint);
      hints.push(hint);
      if (el.swiper) el.swiper.on('zoomChange', dismiss);
    });
  });
})();

(function () {
  if (!document.body.classList.contains('template-index')) return;

  window.dataLayer = window.dataLayer || [];

  function cleanText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function clickLocation(link, url) {
    if (link.closest('.main-nav, .megamenu')) return 'header';
    if (link.closest('footer')) return 'footer';
    if (link.closest('.trade-band, [data-section-type="trade-program-band"]')) return 'trade';
    if (link.closest('.homepage-split')) return 'showroom';
    if (link.closest('.section-full-screen-media')) return 'hero';
    if (url.pathname.indexOf('/products/') === 0) return 'featured_products';
    if (url.pathname.indexOf('/blogs/') === 0) return 'journal';
    if (url.pathname.indexOf('/collections/') === 0) return 'collections';
    return 'homepage_other';
  }

  function linkType(url, href) {
    if (href.charAt(0) === '#') return 'anchor';
    if (url.origin !== window.location.origin) return 'external';
    if (url.pathname.indexOf('/products/') === 0) return 'product';
    if (url.pathname.indexOf('/collections/') === 0) return 'collection';
    if (url.pathname.indexOf('/pages/') === 0) return 'page';
    if (url.pathname.indexOf('/blogs/') === 0) return 'blog';
    return 'other';
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href]');
    if (!link) return;

    var href = link.getAttribute('href') || '';
    if (!href || href.indexOf('javascript:') === 0) return;

    var url;
    try {
      url = new URL(link.href, window.location.origin);
    } catch (error) {
      return;
    }

    var text = cleanText(
      link.getAttribute('aria-label') ||
      link.innerText ||
      (link.querySelector('img') && link.querySelector('img').getAttribute('alt'))
    ) || 'image_link';

    window.dataLayer.push({
      event: 'homepage_navigation',
      click_location: clickLocation(link, url),
      link_text: text.slice(0, 100),
      link_url: url.origin === window.location.origin
        ? (url.pathname + url.search + url.hash).slice(0, 500)
        : url.href.slice(0, 500),
      link_type: linkType(url, href)
    });
  }, true);
})();
